import { CartButton, viewCart } from 'cart';
import classNames from 'classnames';
import { push } from 'connected-react-router';
import { DeliveryOptionsButton } from 'delivery';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import './MobileBottomNavigation.scss';
function MobileBottomNavigation({ cartCount, hasUnavailableProducts, }) {
    const dispatch = useDispatch();
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const [isFirstRun, setIsFirstRun] = useState(true);
    const classes = classNames({
        'mobile-bottom-navigation__cart-button': true,
        'mobile-bottom-navigation__cart-button--animated': shouldAnimate,
    });
    useEffect(() => {
        if (!isFirstRun) {
            setShouldAnimate(true);
            setTimeout(() => {
                setShouldAnimate(false);
            }, 1000);
        }
        else {
            setIsFirstRun(false);
        }
    }, [cartCount]);
    return (React.createElement("div", { className: "mobile-bottom-navigation" },
        React.createElement(DeliveryOptionsButton, null),
        React.createElement("div", { className: classes },
            React.createElement(CartButton, { cartCount: cartCount, hasUnavailableProducts: hasUnavailableProducts, onClick: () => {
                    dispatch(viewCart());
                    dispatch(push('/cart'));
                } }))));
}
function mapStateToProps({ cart }) {
    return {
        cartCount: cart.products.reduce((prev, curr) => prev + curr.quantity, 0),
        hasUnavailableProducts: cart.hasDisabledProductsForRegion || !cart.hasEnoughQuantity,
    };
}
export default connect(mapStateToProps)(MobileBottomNavigation);
